<div>
    <header>
        <p>*Nome do cliente* - Resumo do Guia gerado em *Dia* de *Mês* de *Ano* </p>
        <img src="../../../../../assets/header-image.png" alt="">
    </header>
</div>